//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { getDateString } from "@/tool/index";
import { api_myranking } from "../../api";

export default {
  data() {
    return {
      loading: false,
      date: new Date(),
      rank: {
        month: {},
        week: {},
        day: {},
      },
    };
  },
  computed: {
    ...mapState(["user"]),
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    getDateString,
    changeDate() {
      console.error(
        getDateString({ string: "YYYY-MM-DD hh:mm:ss", date: this.date })
      );
    },
    goHis() {
      this.$router.push({
        name: "rankHis",
      });
    },
    getData() {
      console.log("进来没");
      if (this.loading) return;
      this.rank = {
        month: {},
        week: {},
        day: {},
      };
      this.loading = true;
      api_myranking()
        .then((res) => {
          if (res?.data?.data) {
            res.data.data.forEach((item) => {
              if (item.type == 0) {
                this.rank.day = item;
              }
              if (item.type == 1) {
                this.rank.week = item;
              }
              if (item.type == 2) {
                this.rank.month = item;
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
